import { h, render, Fragment } from 'preact';
import clsx from 'clsx';
import AutoPlayVideo from '../media/AutoPlayVideo';
import { hasRichTextContent } from '../utils/helpers';
import Image from '../utils/image';

export default (element, data) => {
  const init = () => {
    render(<SecondaryHero data={data} />, element);
  };

  // eslint-disable-next-line no-shadow
  const SecondaryHero = ({ data }) => {
    // eslint-disable-next-line consistent-return
    const renderCta = () => {
      if (data.cta_url && data.cta_label) {
        return (
          <div className="laptop:mt-[14px] mt-[10px]">
            <a
              href={data.cta_url}
              className="btn-primary-stroke link-unstyled inline-flex justify-center pt-[14.5px] pb-[14.5px]"
            >
              {data.cta_label}
            </a>
          </div>
        );
      }
    };

    // eslint-disable-next-line consistent-return
    const renderTitle = () => {
      const sectionTitle = data.title || data.collection?.title;

      if (sectionTitle || hasRichTextContent(data.titleRte)) {
        if (hasRichTextContent(data.titleRte)) {
          return (
            <div
              className="rte laptop:mb-[11px] mb-[6px]"
              dangerouslySetInnerHTML={{
                __html: data.titleRte,
              }}
            />
          );
        }
        if (sectionTitle) {
          return (
            <h3 className="h5 laptop:mb-[11px] mb-[6px] uppercase break-words">
              {sectionTitle}
            </h3>
          );
        }
      }
    };

    // eslint-disable-next-line consistent-return
    const renderDescription = () => {
      const sectionDescription = hasRichTextContent(data?.description)
        ? data.description
        : null;
      const collectionDescription = hasRichTextContent(
        data?.collection?.description,
      )
        ? data.collection.description
        : null;
      const description = sectionDescription || collectionDescription || null;

      if (description) {
        return (
          <div
            className="font-14 leading-5 rte"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        );
      }
    };

    // eslint-disable-next-line consistent-return
    const renderEyebrow = () => {
      const eyebrow = data?.eyebrow;

      if (eyebrow) {
        return (
          <div className="text-5 laptop:text-[24px] leading-[1.4] italic laptop:leading-[1.33] heading-base laptop:mb-3 mb-[6px]">
            {eyebrow}
          </div>
        );
      }
    };

    // eslint-disable-next-line consistent-return
    const renderImage = () => {
      const imgLink = data?.image || data.collection?.image;

      if (imgLink) {
        return (
          <div className="laptop:min-h-[500px] relative pt-[52%] min-h-[195px]">
            <Image
              classes="w-full h-full object-cover object-center absolute inset-0"
              src={imgLink}
            />
          </div>
        );
      }
    };

    const renderBlocks = () => (
      <ul className="mt-2.5 laptop:mt-8">
        {data.blocks.map((block, index) => (
          <li
            className="flex gap-5 items-start laptop:items-center mb-4 laptop:mb-7 last-of-type:mb-0"
            key={index}
            style={{ justifyContent: data?.text_position }}
          >
            <Image
              srcWidths={{ sm: 64, lg: 96 }}
              width={96}
              heigh={96}
              classes="object-contain w-8 h-8 laptop:h-12 laptop:w-12"
              src={block.icon}
            />
            <div>
              <p className="font-medium font-14 mb-0.5">{block.heading}</p>
              <p
                className="font-14"
                dangerouslySetInnerHTML={{
                  __html: block.description,
                }}
              ></p>
            </div>
          </li>
        ))}
      </ul>
    );

    return (
      <>
        <div
          className={clsx(
            data.direction === 'text_left'
              ? 'laptop:flex-row'
              : 'laptop:flex-row-reverse',
            'flex flex-col-reverse',
          )}
          style={{ background: data.section_bg }}
        >
          <div
            className={
              // eslint-disable-next-line max-len
              clsx(
                data.video || data.image || data.collection.image
                  ? 'laptop:w-[33%]'
                  : 'laptop:w-[561px]',
                'flex flex-col justify-center laptop:pl-10 pl-5 laptop:pr-10 pr-5 laptop:pt-[60px] pt-8 laptop:pb-[60px] pb-8',
              )
            }
            style={{textAlign: data?.text_position}}
          >
            {renderEyebrow()}
            {renderTitle()}
            {data.blocks?.length ? renderBlocks() :
            <>
              {renderDescription()}
              {renderCta()}
            </>
            }
          </div>

          {data.video || data.image || data.collection.image ? (
            <div className="laptop:w-[66.7%] flex flex-col justify-center">
              {data.video ? (
                <AutoPlayVideo
                  mobileVideo={data.video}
                  desktopVideo={data.video}
                  classNames={'tablet:max-h-[100%] max-h-[195px] object-cover'}
                />
              ) : (
                renderImage()
              )}
            </div>
          ) : (
            ''
          )}
        </div>
      </>
    );
  };

  init();
};
